export default __webpack_public_path__ + "static/media/reAssignLight.e4cc9c6c.svg";